import * as React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@estee/elc-buttons';
import { translate } from '@estee/elc-service';
import { VTO_SAVE_MATCHES, VTO_REMOVE_MATCHES } from '../../constants/DataTestIdAttributes';
import { classes } from '~utils/Classes';

interface IVtoSaveMatch {
    saveMatches(): void;
    removeMatches(): void;
    isMatchSaved: boolean;
    isSaveInProgress: boolean;
    translations: {
        saveMyMatch: string;
        removeMyMatch: string;
    };
    isAllShadesTabActive?: boolean;
}

const saveMatchButtonClassNames = classes('vto-save-match');
const removeMatchButtonClassNames = classes('vto-remove-match');

export const VtoSaveMatch = translate(['saveMyMatch', 'removeMyMatch'])(
    observer(
        ({
            saveMatches,
            removeMatches,
            isMatchSaved,
            translations,
            isSaveInProgress,
            isAllShadesTabActive
        }: IVtoSaveMatch) => {
            if (isMatchSaved) {
                return (
                    <Button
                        onClick={removeMatches}
                        data-test-id={VTO_REMOVE_MATCHES}
                        className={removeMatchButtonClassNames}
                    >
                        {translations.removeMyMatch}
                    </Button>
                );
            }

            return (
                <Button
                    onClick={saveMatches}
                    data-test-id={VTO_SAVE_MATCHES}
                    className={saveMatchButtonClassNames}
                    disabled={isSaveInProgress}
                >
                    {translations.saveMyMatch}
                </Button>
            );
        }
    )
);
